<template>
  <div class="contract-list">
    <el-row class="filter-wrap" :gutter="20">
      <el-col :span="4">
        <el-input v-model="form.code" size="small" placeholder="投放编号" @keyup.enter.native="onSearch"></el-input>
      </el-col>
      <el-col :span="4">
        <el-input v-model="form.bloggerName" size="small" placeholder="博主名称" @keyup.enter.native="onSearch"></el-input>
      </el-col>
      <el-col :span="4" class="input-group">
        <el-select v-model="form.mediaType" size="small" placeholder="平台" class="w-100">
          <el-option v-for="(label, value) in mediaConfig.getConfigList('media_ch')" :key="value" :label="label" :value="value"></el-option>
        </el-select>
      </el-col>
      <el-col :span="4">
        <el-input v-model="form.customerName" size="small" placeholder="客户名称" @keyup.enter.native="onSearch"></el-input>
      </el-col>
      <el-col :span="4">
        <el-input v-model="form.contractName" size="small" placeholder="合同名称" @keyup.enter.native="onSearch"></el-input>
      </el-col>
      <el-col :span="4">
        <el-button type="default" size="small" @click="onReset">重置</el-button>
        <el-button type="primary" size="small" @click="onSearch">搜索</el-button>
      </el-col>
    </el-row>
    <div class="table-wrap">
      <div class="btn-text—flex">
        <div class="table-count">投放总数：{{ page.total }}条</div>
        <div>
          <el-badge style="margin:0 25px;" :value="multiSelectList.length" class="item">
            <el-button :disabled="multiSelectList.length>0?false:true" type="primary" size="small" @click="batchClick">批量关联合同</el-button>
          </el-badge>
          <el-button type="primary" size="small" @click="batchImportClick">批量导入</el-button>
          <el-button type="primary" size="small" @click="onExport">导出</el-button>
        </div>
      </div>
      <el-table v-loading="tableLoading" :data="tableData" size="small"  @selection-change="handleSelectionChange">
        <el-table-column type="selection" :selectable='selectable' width="55" align="center"></el-table-column>
        <el-table-column label="投放编号" min-width="120" prop="code" align="center"></el-table-column>
        <el-table-column label="博主名称" prop="bloggerName" min-width="160" align="center">
          <template slot-scope="scope">
            <div class="account-wrap">
              <div class="avatar-out">
                <div class="avatar-in">
                  <div class="img-wrap" v-if="scope.row.avatar">
                    <!--有头像-->
                    <img v-if="scope.row.avatar.indexOf('/qr/code') !== -1" :src="scope.row.avatar" onerror="javascript:this.src='/img/media/wechat_default.png';" class="avatar is-code">
                    <img v-else :src="scope.row.avatar" onerror="javascript:this.src='/img/media/weibo_default.png';" class="avatar">
                  </div>
                  <div class="img-wrap" v-else>
                    <img src="/img/media/weibo_default.png" class="avatar">
                  </div>
                </div>
              </div>
              <div class="info-wrap">
                <el-tooltip :content="scope.row.bloggerName" placement="bottom" effect="light">
                  <div class="nickname"><span>{{ scope.row.bloggerName }}</span></div>
                </el-tooltip>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="平台" prop="mediaType" align="center">
          <template slot-scope="scope">
            {{ mediaConfig.getAppointed("media_ch", scope.row.mediaType, '') }}
          </template>
        </el-table-column>
        <el-table-column label="关联合同" prop="contract" align="center" min-width="180">
          <template slot-scope="scope">
            <div v-if="scope.row.contractName">
              <p>{{ scope.row.contractName }}</p>
              <p>{{ scope.row.contractCode }}</p>
              <p class="non-wrap">（<span :class="['color_' + contractConfig.getAppointed('status_color', scope.row.contractStatus)]">{{ contractConfig.getAppointed("status_summary", scope.row.contractStatus, '') }}</span>）</p>
            </div>
            <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column label="客户名称" prop="customerName" align="center"></el-table-column>
        <el-table-column label="品牌名称" prop="brandName" align="center"></el-table-column>
        <el-table-column label="发布形式" prop="publishType" align="center"></el-table-column>
        <el-table-column prop="status" align="center" label="投放状态">
          <template slot-scope="scope">
            <p>
              {{ deliveryConfig.getAppointed("record_status", scope.row.recordStatus, "") }}
            </p>
          </template>
        </el-table-column>
        <el-table-column label="发布日期" min-width="120" prop="publishTime" align="center">
          <template slot-scope="scope">
            {{ scope.row.publishTime && scope.row.publishTime.split(' ')[0] }}
          </template>
        </el-table-column>
        <el-table-column label="执行价" prop="executePrice" align="center">
          <template slot-scope="scope">
            {{ readableNum(scope.row.executePrice) }}
          </template>
        </el-table-column>
        <el-table-column label="博主其他成本" min-width="120" prop="bloggerOtherCost" align="center">
          <template slot-scope="scope">
            {{ readableNum(scope.row.bloggerOtherCost) }}
          </template>
        </el-table-column>
        <el-table-column label="分成基数金额" min-width="120" prop="shareIncome" align="center">
          <template slot-scope="scope">
            {{ readableNum(scope.row.shareIncome) }}
          </template>
        </el-table-column>
        <el-table-column label="投放状态" prop="status" align="center">
          <template slot-scope="scope">
            {{ deliveryConfig.getAppointed("delivery_status", scope.row.recordStatus, '') }}
          </template>
        </el-table-column>
        <el-table-column label="结算状态" prop="settleStatus" align="center">
          <template slot-scope="scope">
            {{ deliveryConfig.getAppointed("settle_status", scope.row.settleStatus, '') }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="100" fixed="right">
          <template slot-scope="scope">
            <!-- 进行中 -->
            <div v-if="scope.row.contractStatus === contractConfig.Status.Processing ||
            scope.row.contractStatus === contractConfig.Status.EndAssessing ||
            scope.row.contractStatus === contractConfig.Status.EndAssessFail ||
            scope.row.contractStatus === contractConfig.Status.CloseAssessing ||
            scope.row.contractStatus === contractConfig.Status.CloseAssessFail">
              <el-button type="text" size="small" @click="toEdit(scope.row.id)">编辑</el-button>
              <el-button type="text" size="small" @click="onDel(scope.row.id)">删除</el-button>
            </div>
            <!-- 已结案,已关闭,结案审批中,关闭审批中 -->
            <div v-if="scope.row.contractStatus === contractConfig.Status.Ended || 
            scope.row.contractStatus === contractConfig.Status.Closed || 
            scope.row.contractStatus === contractConfig.Status.EndAssessing || 
            scope.row.contractStatus === contractConfig.Status.CloseAssessing">
              <el-button type="text" size="small" @click="toShow(scope.row.id)">查看</el-button>
            </div>
            <!-- 已关闭 -->
            <div v-if="scope.row.contractStatus === contractConfig.Status.Closed">
              <el-button type="text" size="small" @click="onShowReason(scope.row.closeReason)">原因</el-button>
            </div>
            <!-- 关联合同按钮 判断合同是否存在 -->
            <div v-if="scope.row.contractName">
              <!-- 启动审批中、启动审批不通过、进行中时，提供重新关联合同操作 进行中(结案/关闭审批不通过)-->
              <div v-if="scope.row.contractStatus === contractConfig.Status.Starting 
              || scope.row.contractStatus === contractConfig.Status.FailStarting 
              || scope.row.contractStatus === contractConfig.Status.Processing
              || scope.row.contractStatus === contractConfig.Status.EndAssessFail
              || scope.row.contractStatus === contractConfig.Status.CloseAssessFail">
                <el-button v-if="scope.row.contractName" type="text" size="small" @click="associatedContract(scope.row.id,scope.row)">重新关联合同</el-button>
                <el-button v-else type="text" size="small" @click="associatedContract(scope.row.id,scope.row)">关联合同</el-button>
              </div>
            </div>
            <!-- 无关联合同 -->
            <div v-else>
              <el-button type="text" size="small" @click="toEdit(scope.row.id)">编辑</el-button>
              <el-button type="text" size="small" @click="onDel(scope.row.id)">删除</el-button>
              <el-button type="text" size="small" @click="associatedContract(scope.row.id,scope.row)">关联合同</el-button>
            </div>
            <!-- 审核状态按钮 -->
            <div v-if="scope.row.recordStatus === deliveryConfig.recordStatus.AddStart">
              <el-button type="text" size="small" @click="approvalDeatilClick(scope.row.id,1)">启动审批详情</el-button>
            </div>
            <div v-else-if="scope.row.recordStatus === deliveryConfig.recordStatus.AddNoPass">
              <el-button type="text" size="small" @click="approvalDeatilClick(scope.row.noPassReasonAdd,2)">启动审批不通过原因</el-button>
            </div>
            <div v-else-if="scope.row.recordStatus === deliveryConfig.recordStatus.DelStart">
              <el-button type="text" size="small" @click="approvalDeatilClick(scope.row.id,3)">删除审批详情</el-button>
            </div>
            <div v-else-if="scope.row.recordStatus === deliveryConfig.recordStatus.DelNoPass">
              <el-button type="text" size="small" @click="approvalDeatilClick(scope.row.notPassReasonDel,4)">删除审批不通过原因</el-button>
            </div>
            <div>
              <el-button type="text" size="small" @click="checkSettlement(scope.row.id)">是否可以结算</el-button>
            </div>
            <div>
              <el-button type="text" size="small" @click="openTrans(scope.row)">提交返点付款</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-wrap">
        <el-pagination background @size-change="sizeChange" @current-change="currentChange" :current-page.sync="page.pageNum" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="page.pageSize"
          layout="sizes, prev, pager, next, jumper" :total="page.total">
        </el-pagination>
      </div><!-- 分页 -->
      <!-- 关联框架合同 -->
      <contractFramework ref="contractFramework" :contractValue="contractValue" @customChooseSave="customChooseSave" :contractDialog="contractDialog" @contractClose="contractClose"></contractFramework>
    </div>
    <!-- 导入投放记录 -->
    <el-dialog
      title="导入投放记录"
      :visible.sync="dialogVisible"
      width="50%">
      <el-form v-if="promptShow" label-position="top" size="small" :model="ruleForm" ref="ruleForm" label-width="140px" class="demo-ruleForm">
        <div>
          <el-form-item style="height:70px;" label="投放记录文档" prop="path" class="block-form-item w-25">
            <el-upload style="margin-right:60px;" class="upload-demo" :action="'https://upload-z2.qiniup.com'" :before-upload="getBeforeUpload">
              <el-button type="primary">上传文档</el-button>
            </el-upload>
          </el-form-item>
          <el-form-item style="height:70px;" label="投放记录导入模板" prop="path" class="block-form-item w-70">
            <a class="link chaochu" href="javascript:void(0);" @click="downloadFile(moban, '投放记录导入模板')" download="投放记录导入模板">投放记录导入模板.xlsx</a>
          </el-form-item>
        </div>
        <div style="color:#409eff;" v-if="fileData">{{fileData.name}}</div>
        <div class="anniuFlex" style="margin-top:20px;text-align:center;">
					<el-button style="margin-right:60px;" v-if="beforeShow" @click="before_UploadOne" type="primary">导 入</el-button>
          <el-button type="primary" style="margin-right:60px;" v-else :loading="true">导入中</el-button>
          <el-button plain @click="dialogVisible = false">取 消</el-button>
        </div>
      </el-form>
      <div v-else style="margin-top:-10px;text-align:center;">
        <div v-if="successShow==1" class="el-icon-success" style="font-size:60px;color:#67c23a;"></div>
        <div v-if="successShow==2" class="el-icon-error" style="font-size:60px;color:#f5212e;"></div>
        <div v-if="successShow==3" class="el-icon-warning" style="font-size:60px;color:#faad14;"></div>
        <h4 style="font-size:20px;">{{successShow==1?'导入成功':successShow==2?'导入失败':'部分导入成功'}}</h4>
        <div v-if="successShow == 3" style="padding-bottom:20px;">请导出失败投放记录，检查导入格式后再重新导入</div>
        <div class="box-flex">
          <div>导入成功：{{uploadData.successCount}}条</div>
          <div style="margin-left:100px;">导入失败：{{uploadData.failCount}}条</div>
        </div>
        <div>
          <el-button v-if="successShow == 1" @click="dialogVisible = false" type="primary" style="margin-right:60px;" size="small">继续导入</el-button>
          <!-- <el-button type="primary" @click="exportFailure" style="margin-right:60px;">导出失败记录</el-button> -->
          <el-button v-else type="primary" size="small" @click="exportWord" style="margin-right:60px;">导出失败记录</el-button>
          <el-button plain size="small" @click="dialogVisible = false">取 消</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :title="dialogTitleAdd"
      :visible.sync="approvalDialogAdd"
      width="30%">
      <!-- 启动审批详情,盖章审批详情-->
      <div v-if="notPassReasonAdd">{{notPassReasonAdd}}</div>
      <div v-else>
        <div v-if="finalApprovalAdd.auditStatus == 11">
          <div v-if="finalApprovalAdd.staff4NameList" style="padding-top:2px;">
            (四级可审批人：
            <span v-for="(item,index) in finalApprovalAdd.staff4NameList" :key="index">
              {{item}},
            </span>)
          </div>
        </div>
        <div v-if="finalApprovalAdd.auditStatus == 13">
          <div>四级审批人：{{finalApprovalAdd.staff4Name}}</div>
          <div v-if="finalApprovalAdd.staff3NameList" style="padding-top:2px;">
            (三级可审批人：
            <span v-for="(item,index) in finalApprovalAdd.staff3NameList" :key="index">
              {{item}},
            </span>)
          </div>
        </div>
        <div v-if="finalApprovalAdd.auditStatus == 15">
          <div>三级审批人：{{finalApprovalAdd.staff3Name}}</div>
          <div v-if="finalApprovalAdd.staff2NameList" style="padding-top:2px;">
            (二级可审批人：
            <span v-for="(item,index) in finalApprovalAdd.staff2NameList" :key="index">
              {{item}},
            </span>)
          </div>
        </div>
        
        <div style="padding:10px 0;">
          审批状态：{{auditStatusList[finalApprovalAdd.auditStatus]}}
        </div>
        <div>审批备注：{{finalApprovalAdd.auditRemarkAdd}}</div>
      </div>
    </el-dialog>
    <el-dialog
      :title="dialogTitleDel"
      :visible.sync="approvalDialogDel"
      width="30%">
      <!-- 启动审批详情,盖章审批详情-->
      <div v-if="notPassReasonDel">{{notPassReasonDel}}</div>
      <div v-else>
        <div v-if="finalApprovalDel.auditStatus == 11">
          <div v-if="finalApprovalDel.staff4NameList" style="padding-top:2px;">
            (四级可审批人：
            <span v-for="(item,index) in finalApprovalDel.staff4NameList" :key="index">
              {{item}},
            </span>)
          </div>
        </div>
        <div v-if="finalApprovalDel.auditStatus == 13">
          <div>四级审批人：{{finalApprovalDel.staff4Name}}</div>
          <div v-if="finalApprovalDel.staff3NameList" style="padding-top:2px;">
            (三级可审批人：
            <span v-for="(item,index) in finalApprovalDel.staff3NameList" :key="index">
              {{item}},
            </span>)
          </div>
        </div>
        <div v-if="finalApprovalDel.auditStatus == 15">
          <div>三级审批人：{{finalApprovalDel.staff3Name}}</div>
          <div v-if="finalApprovalDel.staff2NameList" style="padding-top:2px;">
            (二级可审批人：
            <span v-for="(item,index) in finalApprovalDel.staff2NameList" :key="index">
              {{item}},
            </span>)
          </div>
        </div>
        
        <div style="pDeling:10px 0;">
          审批状态：{{auditStatusList[finalApprovalDel.auditStatus]}}
        </div>
        <div>审批备注：{{finalApprovalDel.auditRemarkDel}}</div>
      </div>
    </el-dialog>
    <el-dialog title="结算提醒" :visible.sync="settlementVisible" width="40%">
      <div>
        <div style="margin-bottom: 10px">结算条件：</div>
        <div class="invoiceList">
          <span>1，投放记录对应博主已设置税率</span>
          <i v-if="isRate" class="iconfont icon-chenggong color_success"></i><i v-else class="iconfont icon-cuowu color_error"></i>
        </div>
        <div class="invoiceList mt-10">
          <span>2，投放记录对应博主已设置结算方式</span>
          <i v-if="isSettlementMethod" class="iconfont icon-chenggong color_success"></i><i v-else class="iconfont icon-cuowu color_error"></i>
        </div>
        <div class="invoiceList mt-10">
          <span>3，投放记录存在对应的结算分成比例</span>
          <i v-if="isSettlementRate" class="iconfont icon-chenggong color_success"></i><i v-else class="iconfont icon-cuowu color_error"></i>
        </div>
        <div class="invoiceList mt-10">
          <span>4，投放记录已发布</span>
          <i v-if="isPublish" class="iconfont icon-chenggong color_success"></i><i v-else class="iconfont icon-cuowu color_error"></i>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title="dialogTitle" width="60%" :visible.sync="dialogTableVisible">
      <el-form v-if="dialogTitle==='返点付款'" label-position="left" :model="transForm" ref="transForm" label-width="100px" class="demo-ruleform">
        <el-form-item label="返点金额：" class="block-form-item w-50">
          <el-input v-model="transForm.payRebatePrice"></el-input>
        </el-form-item>
        <el-form-item label="备注：" class="block-form-item w-50">
          <el-input type="textarea" v-model="transForm.rebateRemark" rows="1" show-word-limit placeholder="请输入备注" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="收款方" prop="payAccount" class="block-form-item w-50">
          <el-input v-model="transForm.payAccount" size="small" placeholder="收款方" ></el-input>
        </el-form-item>
        <el-form-item label="收款账号" prop="payAccountNum" class="block-form-item w-50" >
          <el-input v-model="transForm.payAccountNum" size="small" placeholder="收款账号" ></el-input>
        </el-form-item>
        <el-form-item label="开户行" prop="depositBank" class="block-form-item w-50" >
            <el-input v-model="transForm.depositBank" size="small" placeholder="开户行" ></el-input>
        </el-form-item>
        <el-form-item label="付款事由" prop="payReason" class="block-form-item w-50">
          <el-input type="textarea" v-model="transForm.payReason" rows="1" show-word-limit placeholder="付款事由" maxlength="100"></el-input>
        </el-form-item>
        <el-form-item label="项目所属部门" prop="payDepart" class="block-form-item w-50">
            <el-select v-model="transForm.payDepart" clearable placeholder="未选择" class="w-100" >
              <el-option label="商务-上海" :value="1"></el-option>
              <el-option label="商务-北京" :value="2"></el-option>
              <el-option label="商务-大嫂" :value="3"></el-option>
              <el-option label="广州长尾" :value="4"></el-option>
            </el-select>
          </el-form-item>
        <el-form-item label="合同附件" prop="fileList">
          <div style="color:#409eff;" v-for="(item,index) in transForm.fileList" :key="index" class="fjList">
            <div>{{item.name}}</div>
            <div class="el-icon-close" style="color:red;" @click="remClick(item,index)"></div>
          </div>
          <el-upload :id="'upload-file-3'" :key="'file-3'" class="upload-demo" :action="'https://upload-z2.qiniup.com'" :on-success="uploadSuccess" :on-error="uploadError"
            multiple :before-upload="beforeUploadPoint" :show-file-list="false">
            <el-button size="small" type="primary" class="btn--green" icon="el-icon-plus">选择文件</el-button>
          </el-upload>
        </el-form-item>
        <div style="margin-top:20px;text-align:center;">
          <el-button type="primary" @click="saveClick()" style="margin-right:60px;" :disabled="submitLoading">确 定</el-button>
          <el-button plain @click="dialogTableVisible = false">取 消</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import xlsx from "xlsx";
import validate from "@/util/validate";
import util from "@/util/util";
import { mediaConfig } from "@/const/config/media";
import { contractConfig } from "@/const/config/contract";
import { deliveryConfig } from "@/const/config/delivery";
import {
  listDelivery,
  exportDelivery,
  delDelivery,
  relateContract,
  putRecordImport,
  deliveryAuditDetail,
  checkSettlement,
  paymentPoint,
  checkPointPay,
} from "@/api/business/delivery";
import {getCustomerPayerInfo} from "@/api/pay/api";

import { mapGetters } from "vuex";
import contractFramework from "@/components/common/contractFramework";
import { qiniuToken } from "@/api/index";
import * as qiniu from "qiniu-js";
export default {
  components: {
    contractFramework
  },
  data() {
    return {
      beforeShow:true, //导入按钮控制
      moban:"/files/投放记录导入模板.xlsx",
      mediaConfig: mediaConfig,
      contractConfig: contractConfig,
      deliveryConfig: deliveryConfig,
      contractDialog:false,
      dialogVisible:false,
      ruleForm:{
        path:"",
        name:"",
        desc:"",
      },
      form: {
        code: "",
        mediaType: "",
        bloggerName: "",
        contractName: "",
        customerName: "",
      },

      page: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },

      tableData: [],
      tableLoading: false,
      multiSelectList:[],
      contractId:"",
      batchType:"",
      contractValue:{},
      fileData:"",
      promptShow:true,
      successShow:"",
      uploadData:"",
      sheetHeader:["*账号平台","*账号名称","*关联合同编号","品牌名称","产品名称","发布形式","发布日期","执行价","投放链接","外部平台","外部平台任务ID","调整方式","调整金额","调整备注","最终返点","平台公司","投放负责人","微任务","预设返点","代下单费用","差旅费用","其他成本","其他成本备注","备注公司","失败信息"],
      approvalDialogAdd:false,
      notPassReasonAdd:"",
      finalApprovalAdd:{},
      dialogTitleAdd:"" ,
      approvalDialogDel:false,
      notPassReasonDel:"",
      finalApprovalDel:{},
      dialogTitleDel:"" ,
      auditStatusList:['','','','','','','','','','','','待4级审批','4级审批不通过','待3级审批','3级审批不通过','待2级审批','2级审批不通过','审批通过' ],
      isRate:false ,
      isSettlementMethod:false,
      isSettlementRate :false ,
      isPublish :false ,
      settlementVisible :false,
      dialogTitle:"",
      transForm:{
        id:"",
        rebateRemark:"",
        payRebatePrice:"",
        fileList:[],
        payAccount:"",
        payAccountNum:"",
        depositBank:"",
        payReason:"",
        payDepart:"",
      },
      dialogTableVisible:false,
      imageIndex:[],
      submitLoading:false,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    remClick(item,index){
      this.transForm.fileList.splice(index,1)
    },
    //导出开票列表
			exportWord(){
				var data = this.uploadData.failDataList
        let dataTable = []
        for (let i in data) {
          let obj = {
            '账号平台': data[i].mediaTypeName,
            '账号名称': data[i].mediaName,
            '关联合同编号': data[i].contractCode,
            '品牌名称': data[i].brandName,
            '产品名称': data[i].productName,
            '发布形式': data[i].publishType,
            '发布日期': data[i].publishTime,
            '执行价': data[i].executePrice,
            '投放链接':data[i].publishUrl,
            '外部平台':data[i].externalPlatform,
            '外部平台任务ID':data[i].externalPlatformTaskId,
            '调整方式':data[i].transMethod,
            '调整金额':data[i].transPrice,
            '调整备注':data[i].transRemark,
            '最终返点':data[i].finalRebate,
            '平台公司':data[i].platfromCompanyName,
            '投放负责人':data[i].recordPrincipal,
            '微任务':data[i].wxjobPrice,
            '预设返点':data[i].presetRebatePrice,
            '代下单费用':data[i].agentOrderPrice,
            '差旅费用':data[i].travelPrice,
            '其他成本':data[i].otherPrice,
            '其他成本备注':data[i].otherPriceRemark,
            '备注公司':data[i].remarkCompany,
            '失败信息':data[i].reason
          }
          dataTable.push(obj);
				}
				  //生成表格
				  var sheet = xlsx.utils.json_to_sheet(dataTable);
				  var tmpdata = xlsx.utils.sheet_add_json(sheet, dataTable, { origin: "A2" });
				  //给A1单元格赋值
				  tmpdata["A1"] = {
				    t: "s",
				    v: `投放记录导入文档说明：
1，账号平台：【必填】请填写：微信/微博/小红书/抖音/B站/快手/淘宝直播
2，账号名称：【必填】请务必填写和系统内名称完全一致的账号名称
3，关联合同：【必填】请填写商务合同编号
4，产品名称/品牌名称/发布形式/投放链接/外部平台/外部平台任务ID/调整原因：格式不限，最多50字
5，发布日期：仅支持输入两种时间格式，示例：2021/04/28 和 2021-04-28
6，执行价/调整金额/最终返点/微任务/预设返点/代下单费用/差旅费用/其他成本：仅支持输入数字，最多保留两位小数，示例：10000.01
7，调整方式：增加/减少
8，平台公司：【必填】请填写名称：薯一薯二文化传媒（上海）有限公司，武汉巨量星图科技有限公司，超电（上海）信息科技有限公司，腾讯科技（深圳）有限公司，宁波布谷鸟广告传媒有限公司，天下秀广告有限公司，广西耀远信息科技有限公司，非商务运营统一开票合作，天下秀科技有限公司,武汉星图新视界科技有限公司,薯鸿文化传媒（上海）有限公司
9，投放负责人：【必填】请填写员工姓名`
				  };
				  // 设置A1标题字体样式
				  tmpdata["A1"].s = {
            font: { sz: 10},
            alignment: { vertical: "center", wrapText: true },
            fill: { bgColor: { indexed: 64 }, fgColor: { rgb: "00b050" }},
				  };
				  //单元格合并
				  tmpdata["!merges"] = [{ 
				    //合并单元格 index都从0开始
				    s: { //s开始
				      c: 0, //开始列
				      r: 0 //开始行
				    },
				    e: { //e结束
				      c: 24, //结束列
				      r: 0 //结束行
				    }
				  }]
          // 设置B2单元格样式
          let colWidthList = []
          this.sheetHeader.forEach((v, index) => {
            tmpdata[this.convert10to26(index + 1) + 2] = {
              t: "s", //类型 s字符串 n数字
              v:v,
              s: {
                font: { sz: 11, color: { rgb: "ff0000" }},
                alignment: { horizontal: "center", vertical: "center", wrapText: true },
                fill: { bgColor: { indexed: 64 }, fgColor: { rgb: "fcd5b4" }}
              }
            }
            colWidthList[index] = index==2 || index==10 || index==16?{ wpx: 100 }:{ wpx: 80 };
          })
        tmpdata['!cols'] = colWidthList;
        tmpdata['!rows'] = [{ hpx: 1000 }];
				const filename = `投放记录失败数据`
        console.log(tmpdata)
				this.openDownloadDialog(this.sheet2blob(tmpdata), `${filename}.xlsx`);
			},
			sheet2blob(sheet, sheetName) {
			  sheetName = sheetName || 'sheet1';
			  var workbook = {
			    SheetNames: [sheetName],
			    Sheets: {},
			  };
			  workbook.Sheets[sheetName] = sheet; // 生成excel的配置项
			
			  var wopts = {
			    bookType: 'xlsx', // 要生成的文件类型
			    bookSST: false, // 是否生成Shared String Table，官方解释是，如果开启生成速度会下降，但在低版本IOS设备上有更好的兼容性
			    type: 'binary'
			  };
			  var wbout = XLSXStyle.write(workbook, wopts);
			  var blob = new Blob([s2ab(wbout)], {
			    type: "application/octet-stream"
			  }); // 字符串转ArrayBuffer
			  function s2ab(s) {
			    var buf = new ArrayBuffer(s.length);
			    var view = new Uint8Array(buf);
			    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
			    return buf;
			  }
			  return blob;
			},
			
			openDownloadDialog(url, saveName) {
			  let href = URL.createObjectURL(url)
			  let a = document.createElement('a');
			  a.href = href;
			  a.download = saveName || ''; // HTML5新增的属性，指定保存文件名，可以不要后缀，注意，file:///模式下不会生效
			  document.body.appendChild(a)
			  a.click()
			  document.body.removeChild(a)
			  setTimeout(() => {
			    URL.revokeObjectURL(url)
			  }, 200);
			},
      convert10to26(num){
        var str = "";
        while (num > 0) {
          var m = num % 26;
          if (m == 0) {
            m = 26;
          }
          str = String.fromCharCode(m + 64) + str;
          num = (num - m) / 26;
        }
        return str;
    },
    //导出失败数据
    exportFailure(){
      const ExportJsonExcel = require('js-export-excel')
      var option={};
      option.fileName = '投放记录失败数据'
      option.datas=[{
        sheetData:this.uploadData.failDataList,//data就是传入的后台数据 作为的参数
        sheetHeader:this.sheetHeader//自定义表头
      }]
      var toExcel=new ExportJsonExcel(option);
      toExcel.saveExcel();
    },
    before_UploadOne(){
      if(this.fileData){
        this.beforeShow = false;
        let formData = new FormData();
        formData.append("file", this.fileData);
        putRecordImport(formData).then(res=>{
          this.beforeShow = true;
          console.log('======导入数据返回======',res)
          if(res.code === 1){
            //文档没数据
            if(res.data.failCount == 0 && res.data.successCount == 0){
              this.$message.warning('导入模版数据为空,请上传正确的模版数据!');
              this.dialogVisible = false;
              this.getList();
              return;
            }
            this.uploadData = res.data;
            // 导入成功进入
            if(res.data.failCount == 0){
              this.promptShow = false;
              this.successShow = 1;
              this.getList();
              return
            }
            //导入失败进入
            if(res.data.successCount == 0){
              this.promptShow = false;
              this.successShow = 2;
              this.getList();
              return
            }
            //部分导入成功失败进入
            if(res.data.failCount>0 && res.data.successCount>0){
              this.promptShow = false;
              this.successShow = 3;
              this.getList();
              return
            }
          }
        })
      }else{
        this.beforeShow = true;
        this.$message({
          message: '请上传投放记录模版!',
          type: 'warning'
        });
      }
    },
    getBeforeUpload(file){
      this.fileData = file
      console.log('======44444=======',file)
    },
    //关联合同
    customChooseSave(item){
      var ids = []
      if(this.batchType == 1){
        this.multiSelectList.forEach(element => {
          ids.push(element.id)
        });
      }else{
        ids = [this.contractId]
      }
      relateContract(ids,item.id).then(res=>{
        if(res.code === 1){
          this.$message({
            message: '关联合同成功!',
            type: 'success'
          });
          this.contractDialog = false
          this.getList();
        }
        console.log('=======关联======',res)
      })
    },
    //多选禁用
    selectable(row,index){
      if(row.contractName){
        if( row.contractStatus === contractConfig.Status.Starting 
          || row.contractStatus === contractConfig.Status.FailStarting 
          || row.contractStatus === contractConfig.Status.Processing
          || row.contractStatus === contractConfig.Status.EndAssessFail
          || row.contractStatus === contractConfig.Status.CloseAssessFail){
          return true
        }else{
          return false
        }
      }else{
        return true
      }
    },
    batchImportClick(){
      this.fileData = "";
      this.promptShow = true;
      this.dialogVisible = true;
    },
    //上传文件成功
    uploadSuccess(res, file) {
      // file 返回的文件信息，也可以在这里调用七牛上传。
      console.log(file, "success");
    },
    //上传文件失败
    uploadError(res, file) {
      console.log("error", res, file);
    },
    //批量关联合同
    batchClick(){
      this.batchType = 1;
      this.contractDialog = true;
      this.$refs.contractFramework.contactShow = false;
      this.$refs.contractFramework.customForm.mediaType = "";
      this.$refs.contractFramework.customForm.mediaId = "";
    },
    //选择
    handleSelectionChange(val){
      this.multiSelectList = val;
    },
    //关联合同
    associatedContract(id,data){
      console.log('===AAA===',data)
      this.contractValue = {
        id:data.contractId,
        name:data.contractName
      }
      this.batchType = 2;
      this.contractId = id;
      this.contractDialog = true;
      this.$refs.contractFramework.customForm.mediaType = data.mediaType;
      this.$refs.contractFramework.customForm.mediaId = data.mediaId;
      this.$refs.contractFramework.contactShow = true;
      console.log('data====',data.contractName,data.contractId)

      // this.$refs.contractFramework.selectCustomId = data.contractId;
      // this.$refs.contractFramework.selectCustom={
      //   name:data.contractName,
      //   id:data.contractId
      // }
    },
    contractClose(){
      this.contractDialog = false;
    },
    /**
     * 监听分页器每页显示的条数变化
     * @param val 条数
     */
    sizeChange(val) {
      this.page.pageNum = 1;
      this.page.pageSize = val;
      this.getList();
    },
    /**
     * 监听页数变化
     * @param val 当前页数
     */
    currentChange(val) {
      this.page.pageNum = val;
      this.getList();
    },
    // 重置
    onReset() {
      this.form = {
        code: "",
        customerName: "",
        contractMoneyMin: "",
        contractMoneyMax: "",
        contractStatus: "",
      };
      this.onSearch();
    },
    // 搜索
    onSearch() {
      if (this.form.contractMoneyMin && this.form.contractMoneyMax) {
        if (
          parseInt(this.form.contractMoneyMin) >
          parseInt(this.form.contractMoneyMax)
        ) {
          this.$message.error("最小合同金额不能大于最大合同金额");
          return;
        }
      }
      this.page.pageNum = 1;
      this.getList();
    },
    // 获取列表
    getList() {
      let queryObj = validate.removeFilterNull(this.form);
      queryObj.pageNum = this.page.pageNum;
      queryObj.pageSize = this.page.pageSize;
      this.tableLoading = true;
      listDelivery(queryObj)
        .then((res) => {
          this.tableData = res.data || [];
          this.page.total = res.total;
          this.tableLoading = false;
        })
        .catch((err) => {
          this.tableData = [];
          this.page.total = 0;
          this.tableLoading = false;
        });
    },
    /**
     * 删除
     */
    onDel(id) {
      this.$confirm("删除将无法恢复，确认删除该投放记录吗？", "确认删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "",
        customClass: "msgbox contnt-center",
      })
        .then(() => {
          delDelivery({ id }).then((res) => {
            this.$message.success("删除成功");
            this.getList();
          });
        })
        .catch(() => {});
    },
    /**
     * 导出
     */
    onExport() {
      let queryObj = validate.removeFilterNull(this.form);
      exportDelivery(queryObj).then((res) => {
        const blob = new Blob([res.data]);
        let fileName = res.headers["content-disposition"].split("filename=")[1];
        fileName = decodeURI(fileName);
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, fileName);
        } else {
          const linkNode = document.createElement("a");
          linkNode.download = fileName; //a标签的download属性规定下载文件的名称
          linkNode.style.display = "none";
          linkNode.href = URL.createObjectURL(blob); //生成一个Blob URL
          document.body.appendChild(linkNode);
          linkNode.click(); //模拟在按钮上的一次鼠标单击
          URL.revokeObjectURL(linkNode.href); // 释放URL 对象
          document.body.removeChild(linkNode);
        }

        setTimeout(() => {
          this.$message.success("导出成功，等待文件下载完毕");
        }, 500);
      });
    },
    /**
     * 展示原因
     * @param reason 原因
     */
    onShowReason(reason) {
      reason = reason || "";
      this.$alert(reason, "投放失败原因", {
        showConfirmButton: false,
        closeOnClickModal: true,
        customClass: "msgbox",
        callback: (action) => {},
      });
    },
    /**
     * 跳转到编辑页
     */
    toEdit(id) {
      let router = this.$router.resolve({
        path: "/business/delivery-log/edit",
        query: { id },
      });
      window.open(router.href, "_blank");
    },
    /**
     * 跳转到查看页
     */
    toShow(id) {
      let router = this.$router.resolve({
        path: "/business/delivery-log/show",
        query: { id,type:'show' },
      });
      window.open(router.href, "_blank");
    },


    /**
     * 结算
     */
    checkSettlement(id, isComplete) {
      checkSettlement(id).then((res) => {
        console.log("结算条件==========", res.data);
        this.settlementVisible = true;
        if (res.code == 1) {
          if (res.data) {
            this.isRate = res.data.isRate;
            this.isSettlementMethod = res.data.isSettlementMethod;
            this.isSettlementRate = res.data.isSettlementRate;
            this.isPublish = res.data.isPublish;
          }
        }
      });
    },


    //返点付款弹窗
    openTrans(obj){
      checkPointPay(obj.id).then((res) => {
        if (res.code == 1) {
          if(res.data.isPay){
            this.$message.error("该投放记录已经提交返点付款，无法重复提交！");
            return false;
          }else{
            this.dialogTitle = '返点付款' ;
            this.dialogTableVisible = true ;
            console.log("======"+obj);
            var contractCode = obj.contractCode ;
            getCustomerPayerInfo({contractCode }).then(res=>{
              this.transForm.payAccount = res.data.companyName ;
              this.transForm.payAccountNum = res.data.bankAccount ;
              this.transForm.depositBank = res.data.depositBank ;
              this.transForm.id = obj.id;
              this.transForm.payRebatePrice = obj.payRebatePrice;
              this.transForm.rebateRemark = obj.rebateRemark;
              this.transForm.payRebatePrice = obj.presetRebatePrice ;
            })
          }
          
        }
      });
      
    },


    //返点付款提交
    saveClick(){
      this.submitLoading = true ;
      if(this.transForm.payReason == ''){
			  this.$message.error('请先填写付款事由');
        this.submitLoading = false ;
			  return
		  }
      if(this.transForm.payDepart == ''){
			  this.$message.error('请先填写归属部门');
        this.submitLoading = false ;
			  return
		  }
      paymentPoint(this.transForm).then(res=>{
        if(res.code === 1){
          this.$message({
            message: '提交返点付款成功!',
            type: 'success'
          });
          this.$emit('editSubmit')
          this.dialogTableVisible = false;
          this.submitLoading = false;
        }
      }).catch((err) => {
          this.submitLoading = false;
        });
    },
    

    //返点付款附件上传
    beforeUploadPoint(file) {
      this.imageIndex.push(file);
      if (file.size > 500 * 1024 * 1024) {
        this.$message.error("文件大小不能超过500M");
        return false;
      }
      qiniuToken()
        .then((res) => {
          let that = this;
          let fileName = Date.now() + file.name;
          var observable = qiniu.upload(file, fileName, res.data);
          observable.subscribe({
            next(res) {},
            error(error) {
              this.$message.error("上传失败");
            },
            complete: (complete) => {
              let qiniuBaseUrl = "https://yhgtk.fruitbloom.com.cn/";
              this.transForm.fileList.push({
                "name": file.name,
                "path": qiniuBaseUrl + complete.key
              })
            },
          });
        })
        .catch((error) => {});
      return false;
    },

    /**
     * 数字可读化
     * @param num 数字
     */
    readableNum(num) {
      if (!num && num !== 0) return "";
      return util.priceFormat(num);
    },

    //审批详情
    async approvalDeatilClick(id,type){
      this.notPassReasonAdd = '';
      this.notPassReasonDel = '';
      if(type == 1){
        this.finalApprovalAdd = await this.getAuditDetail(id,type);
        this.dialogTitleAdd = '启动审批详情';
        this.approvalDialogAdd = true;
      }else if(type == 2){
        this.dialogTitleAdd = '启动审批不通过原因'
        this.approvalDialogAdd = true;
        this.notPassReasonAdd = id;
      }else if(type == 3){
        this.finalApprovalDel = await this.getAuditDetail(id,type);
        this.dialogTitleDel = '删除审批详情';
        this.approvalDialogDel = true
      }else if(type == 4){
        this.dialogTitleDel = '删除审批不通过原因';
        this.approvalDialogDel = true;
        this.notPassReasonDel = id;
      }
    },


    async getAuditDetail(id,type){
      let res = await deliveryAuditDetail({id,type});
      console.log('=====审批详情=====',id);
      return res.data;
    },
  },
  computed: {
    ...mapGetters(["permissions", "dicts"]),
  },
};
</script>

<style lang="scss" scoped>
.anniuFlex{
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-text—flex{
  margin: 15px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.box-flex{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}
//账号名称
.account-wrap {
  display: flex;
  cursor: pointer;
  //头像
  .avatar-out {
    /*width: 50%;*/
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .avatar-in {
      position: relative;
      width: 42px;
      height: 42px;
      margin-right: 10px;
      float: right;
      .img-wrap {
        position: relative;
        border-radius: 50%;
        width: 42px;
        height: 42px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          &.is-code {
            position: absolute;
            top: -84px;
            left: -84px;
            width: 210px;
            height: 210px;
          }
        }
      }
    }
  }
  //基础信息
  .info-wrap {
    display: flex;
    align-items: center;
    width: 50%;
    font-size: 12px;
    text-align: left;
    .nickname {
      max-width: 65px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.table-count-wrap {
  display: flex;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.block-form-item {
  &.w-25 {
    display: inline-block;
    width: 24%;
    margin-right: 1%;
    height: 64px;
  }
  &.w-50 {
    display: inline-block;
    width: 49%;
    margin-right: 1%;
    height: 64px;
  }

  &.w-70 {
    display: inline-block;
    width: 70%;
    margin-right: 1%;
    height: 64px;
  }

  &.w-99 {
    width: 99%;
    margin-right: 1%;
  }
  .invoiceList {
  display: flex;
  justify-content: space-between;
  }
  .mt-10 {
    margin-top: 10px;
  }
}
.fjList{
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}
</style>